import { track } from '@promoboxx/redux-stores/src/stores/analytics/actions'
import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectTrackingData } from '../../../stores/analytics/selectors'

export default function useTracking() {
  const dispatch = useDispatch()
  const trackingData = useSelector(selectTrackingData)
  const trackingDataRef = useRef(trackingData)

  useEffect(() => {
    trackingDataRef.current = trackingData
  })

  return {
    /**
     * @param {Parameters<typeof track>[0]} payload
     */
    track: useCallback(
      (payload) => {
        dispatch(
          track({
            event: payload.event,
            data: {
              ...trackingDataRef.current,
              ...payload.data,
            },
          }),
        )
      },
      [dispatch],
    ),
  }
}
